import API from '@/views/Fdc/Apis/'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

/**
 * Report > Fault Analysis Report - EQP Model Analysis Chart
 */
export default {
  name: 'EqpModelAnalysisChart',
  props: {
    parentInfo: {
      type: Object,
      default () {
        return null
      }
    }
  },
  watch: {
    /**
     * parentInfo 변화 감지
     * EQP Model Analysis Chart data를 조회합니다.
     */
    parentInfo () {
      this.search(this.parentInfo)
    }
  },
  methods: {
    /**
     * EQP Model Analysis Chart data 조회
     * @param {Object} condition 조회 조건
     */
    async search (condition) {
      if (condition !== null) {
        let payload = {
          fab: condition.fab,
          area: condition.area,
          eqpModel: condition.eqpModel,
          fromDate: condition.fromDate,
          toDate: condition.toDate
        }

        this.condition = condition

        // await API.FdcAnalysisReport.getEqpModelFaultAnalysisChart(payload, this.callbackEqpModelChart)
        await API.Report.getFaultChartEqpModels(payload, this.callbackEqpModelChart)
      } else {
        this.$emit('data-selected', null)
        BriqueChart.deleteTraces(document.getElementById('eqpModelChart'), 0)
      }
    },
    /**
     * EQP Model Analysis Chart data 조회 callback
     * @param {*} response EQP Model Analysis Chart data 조회 결과
     */
    callbackEqpModelChart (response) {
      if (response && response.status === 200) {
        this.drawChart(response.data)

        if (response.data[0].x.length > 0) {
          this.condition.eqpModel = response.data[0].x[0]
          this.$emit('data-selected', this.condition)
        } else {
          this.$emit('data-selected', null)
        }
      }
    },
    /**
     * setInterval 설정
     * @param {*} nSelIndex chart data index
     * 주기적으로 실행하면서 선택된 chart의 data를 조회하여 data가 있을경우 cleareInterval을 실행합니다.
     */
    // resetInterval (nSelIndex) {
    //   let self = this
    //   var flex = this.$refs.eqpModelChart.chart
    //   this.interval = setInterval(function () {
    //     flex.selection = flex.series[0]
    //     var ele = flex.selection.getPlotElement(nSelIndex)
    //     if (ele) {
    //       clearInterval(self.interval)
    //       flex.selection.collectionView.currentItem = flex.selection.collectionView.items[nSelIndex]
    //       flex.selection.collectionView.currentPosition = nSelIndex
    //     }
    //   }, this.updateInterval)
    // },
    /**
     * Draw Chart
     * @param {*} traces plotly chart data
     */
    drawChart (traces) {
      // private final String name = "Eqp Model";
      // private final String hovertemplate = "Area: %{text.area}<br>EQP Model: %{label}<br>Cnt: %{value:,}<extra></extra>";
      // private final String type = "bar";
      // private final Boolean showlegend = true;
      traces.forEach(trace => {
        trace.name = 'EQP Model'
        trace.type = 'bar'
        trace.hovertemplate = '<b>Area:</b> %{text.area}<br><b>EQP Model:</b> %{label}<br><b>Cnt:</b> %{value:,}<extra></extra>'
      })
      const layout = {
        legend: {
          orientation: 'h',
          y: 1.2
        },
        hoverlabel: {
          align: 'left'
        }
      }
      const config = {
        responsive: true,
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true
      }
      BriqueChart.newPlot('eqpModelChart', traces, layout, config).then(() => {
        document.querySelector('#eqpModelChart').on('plotly_click', event => {
          this.condition.eqpModel = event.points[0].label
          this.$emit('data-selected', this.condition)
        })
      })
    }
  },
  data () {
    return {
      // eqpModelAnalysisItems: [] // EQP Model Analysis Chart data
      // selectedIndex: null, // 선택된 chart data index
      // interval: null, // setInterval 객체
      // updateInterval: 100 // setInterval 주기
    }
  }
}
